export const TagManagerEvents = {
  PRE_LOAD: 'dstm_pre_load',
  POST_LOAD: 'dstm_post_load',

  PRE_TRACK_EVENT: 'dstm_pre_track_event',
  POST_TRACK_EVENT: 'dstm_post_track_event',
  PRE_TRACK_CUSTOM_EVENT: 'dstm_pre_track_custom_event',
  POST_TRACK_CUSTOM_EVENT: 'dstm_post_track_custom_event',
  PRE_TRACK_CLICK_EVENT: 'dstm_pre_track_click_event',
  POST_TRACK_CLICK_EVENT: 'dstm_post_track_click_event',
  PRE_TRACK_FORM_SUBMIT_EVENT: 'dstm_pre_track_form_submit_event',
  POST_TRACK_FORM_SUBMIT_EVENT: 'dstm_post_track_form_submit_event',
  PRE_TRACK_FORM_CONFIRMATION_EVENT: 'dstm_pre_track_form_confirmation_event',
  POST_TRACK_FORM_CONFIRMATION_EVENT: 'dstm_post_track_form_confirmation_event',
};
